export default __webpack_public_path__ + "static/media/ag-icon-active.af80fc9a.svg";